import api from '@/lib/axios';

class FormDataService {
  async getUserData(userId) {
    try {
      const response = await api.get(`/v1/get-user-data`, {
        params: { user_id: userId }
      });
      return response.data;
    } catch (error) {
      console.error('Error in getUserData:', error);
      throw error;
    }
  }

  async saveStepData(payload) {
    try {
      const response = await api.post(`/v1/save-step`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveStepData:', error);
      throw error;
    }
  }

  async saveFileData(payload) {
    try {
      const response = await api.post(`/v1/save-step`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveFileData:', error);
      throw error;
    }
  }

  async saveSkipStatus(payload) {
    try {
      const response = await api.post(`/v1/save-step`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveSkipStatus:', error);
      throw error;
    }
  }
}

export const formDataService = new FormDataService(); 